import { useState, useEffect, memo } from 'react';
import { useAuth } from '../../../../providers/CustomAuthProvider';
import { DEV_URL, rget, rpost } from "../../../../utils/requests";
import { Card, Row, Col } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import LoadingButton from 'components/LoadingButton';
import { useForm } from 'react-hook-form';
import { useShowSnackbar } from 'hooks';
import FormInput from 'components/FormInput/index';

const NotificationChannels = memo(() => {
    const { user, clientId } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    const showSnackbar = useShowSnackbar();
    const {
        handleSubmit,
        register,
        control,
        formState: { errors },
        setValue,
        watch
    } = useForm({});

    const shouldDisplayTriggerDays = watch('allowWeb', false) || watch('allowEmail', false);
    const onSubmit = async (e) => {
        const notificationAdvanceDays = shouldDisplayTriggerDays ? e?.notificationTriggerInDays : undefined;
        const postParams = {
            Id: e?.id,
            SecureId: user?.sub,
            allowEmail: e?.allowEmail,
            allowSms: e?.allowSms,
            allowWeb: e?.allowWeb,
            notificationTriggerInDays: notificationAdvanceDays
        };

        try {
            setIsLoading(true);
            let response = await rpost(
                `${DEV_URL}/api/client/${clientId}/user/notification-settings`,
                postParams
            );

            showSnackbar(
                response?.data || 'something went wrong!',
                response?.data && (response?.status == 200) ? 'success' : 'error'
            )
            if (response?.status == 200) {
                fetchNotificationSettings();
            }
            
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching notification settings:", error);
        }
    };
    const fetchNotificationSettings = async () => {
        const queryParams = {
            secureId: user?.sub
        };

        try {
            setIsLoading(true);
            let response = await rget(
                `${DEV_URL}/api/client/${clientId}/user/notification-settings`,
                { params: queryParams }
            );
            response= response?.data
            if (response) {
                setValue('id', response.id);
                setValue('allowEmail', response.allowEmail);
                setValue('allowWeb', response.allowWeb);
                setValue('notificationTriggerInDays', response.notificationTriggerInDays);
              }

            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching notification settings:", error);
        }
    };

    useEffect(() => {
        fetchNotificationSettings();
    }, []);

    return (
        <div>
            <h4>Notifications</h4>
            <Row>
                <Col md={12}>
                    <Card>
                        <Card.Body>
                            <Form>
                                <FormInput
                                    type="hidden"
                                    name='id'
                                    register={register}
                                />
                                <Row>
                                    <Col md={2}>
                                        <b>Notifications Channels: </b>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Check 
                                            type="checkbox"
                                            label="Email"
                                            name='allowEmail'
                                            {...register('allowEmail')}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Check 
                                            type="checkbox"
                                            label="Web"
                                            name='allowWeb'
                                            {...register('allowWeb')}
                                        />
                                    </Col>
                                </Row>
                                <br/>
                                <span className='mr-3' style={{ width: '150px', display: 'unset' }}>License Expirations </span>
                                <FormInput
                                    type="number"
                                    name='notificationTriggerInDays'
                                    placeholder="No. of days"
                                    containerClass="d-inline-block mb-0"
                                    className="d-inline-block"
                                    style={{ width: '100px', display: 'unset' }}
                                    disabled={!shouldDisplayTriggerDays}
                                    register={shouldDisplayTriggerDays ? register : undefined}
                                    validation={shouldDisplayTriggerDays ? {
                                        required: {
                                            value: true,
                                            message: 'Number of days is required for advance notifications!'
                                        },
                                        min: {
                                        value: 1,
                                        message: 'Value must be at least 1'
                                        },
                                        max: {
                                            value: 100,
                                            message: 'Value must not exceed 100'
                                        }
                                    } : undefined}
                                    errors={errors}
                                />
                                <span className='mr-3' style={{ width: '150px', display: 'unset' }}> days before.</span>
                                {!shouldDisplayTriggerDays ? <br/> : null}
                                
                                <LoadingButton
                                    isLoading={isLoading}
                                    type="button"
                                    className='float-end'
                                    onClick={handleSubmit(onSubmit)}
                                > 
                                    Save Changes
                                </LoadingButton>
                            </Form>
                            
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            
        </div>
    );
});

export default NotificationChannels;
